import React, { Suspense } from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';
import { billedMedicalPackagesList, billedMedicalPackagesStatus } from '../constants/constants';
import PageLoader from '../components/PageLoader/PageLoader';
import BilledMedicalPackageTabsContainer from '../containers/BilledMedicalPackageContainer/BilledMedicalPackageTabsContainer';

const BilledMedicalPackagePage = React.lazy(() => import('../pages/BilledMedicalPackagePage/BilledMedicalPackagePage'));
const BilledMedicalPackageStatusPage = React.lazy(() => import('../pages/BilledMedicalPackageStatusPage/BilledMedicalPackageStatusPage'));

const BilledMedicalPackagesRoutes = props => (
    <BilledMedicalPackageTabsContainer history={props.history} match={props.match}>
        <Suspense fallback={<PageLoader />}>
            <Route path={billedMedicalPackagesList} exact component={BilledMedicalPackagePage} />
            <Route path={billedMedicalPackagesStatus} exact component={BilledMedicalPackageStatusPage} />
        </Suspense>
    </BilledMedicalPackageTabsContainer>
);

BilledMedicalPackagesRoutes.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object.isRequired,
};

BilledMedicalPackagesRoutes.defaultProps = {
    history: {},
};

export default BilledMedicalPackagesRoutes;
